export enum Roles {
  admin = 'Admin',
}

export default Roles;  
